import React, {Component} from 'react';

import gql from 'graphql-tag';

import {renderForError, renderWhileLoading} from 'App/util/recompose/graphql';
import {Card, CardBody, CardFooter, CardHeader} from 'reactstrap';
import ExportableTable from 'App/components/ExportableTable';

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.head = ['Date (dd.mm.yyyy)', 'Feature', 'Description'];

    this.news = [
      ['02.05.2018', <b>release v.2.0.0</b>, ''],
      ['', 'Upgrade basic technology', <div>Updated the app to the new version of the underlying <a
        href="https://cci-generic.uniklinik-freiburg.de">FORMED</a>.</div>],
      ['28.02.2018', <b>release v.1.1.0</b>, ''],
      ['', 'export functionality', <div>Patients can be exported in a XLS file (grants required).</div>],
      ['15.01.2018', <b>release v.1.0.2</b>, ''],
      ['', 'Added last db refresh date',
        <div>The date of when the last merge database was generated, is displayed in the footer.</div>],
      ['', 'Weekly db refresh', <div>Once a week the database gets automatically refreshed.</div>],
      ['', 'Updated basic technology', <div>Updated the app to the new version of the underlying <a
        href="https://cci-generic.uniklinik-freiburg.de">toolkit</a>.</div>],
      ['12.10.2017', <b>release v.1.0.1</b>, ''],
      ['', 'Fixed session bug', <div>After logout browser window doesn't need to be closed before login again.</div>],
      ['', 'Updated frontend js-libs', <div>Updated all used libraries. This makes the application more stable.</div>],
      ['', 'Fixed contact email',
        <div>Fixed contact email below (when clicking on Raphael Scheible). I'm sorry about that!</div>],
      ['29.09.2017', <b>release v.1.0.0</b>, <div>First release of the reporting tool.</div>],
    ];
  }

  render() {
    return (
      <div className="animated fadeIn">
        {/*<Card>*/}
          {/*<CardHeader>*/}
            {/*<i className="fa fa-align-justify"></i><strong>Changelog</strong>*/}
          {/*</CardHeader>*/}
          {/*<CardBody>*/}
            {/*<ExportableTable id="table_news" data={this.news} head={this.head}/>*/}
          {/*</CardBody>*/}
        {/*</Card>*/}
        <Card>
          <CardHeader>Feature requests</CardHeader>
          <CardBody>
            <p>We'd like to encourage you sending us feature requests for new statistics and visualizations.
              Visualization is done by the library highcharts. <a href="https://www.highcharts.com/demo">Here</a> you
              can get an impression of what's possible with that library. If you have some more complex statistics which
              uses R code, please send us the code as well, so that we can integrate it within the reporting tool. If
              you already know how the chart needs to look alike, it's helful to have all these information
              (drawings/images). We are looking forward to see this reporting tool grow.</p>
            <p>Contact: <a href="mailto:raphael.scheible@uniklinik-freiburg.de?subject=[reporting] request">Raphael
              Scheible</a></p>
          </CardBody>
        </Card>
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js